import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { BillingPaymentStatus } from "@/types/billing-transactions";
import { NonEditableFormField } from "../../guests/components/form/FormFields";
import { useTranslation } from "react-i18next";

const PaymentStatusSelect = ({
  value,
  onChange,
  isEdit = true,
}: {
  isEdit?: boolean;
  value: BillingPaymentStatus;
  onChange: (value: BillingPaymentStatus) => void;
}) => {
  const { t } = useTranslation();

  if (!isEdit) {
    return (
      <NonEditableFormField
        value={value}
        isCopy={false}
        label={t("reservation.form.paymentStatus")}
      />
    );
  }

  return (
    <div>
      <label className="block text-sm font-medium text-black mb-2">
        {t("reservation.form.paymentStatus")}
      </label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="w-full">
          <SelectValue
            placeholder={t("reservation.placeholders.chooseStatus")}
          />
        </SelectTrigger>
        <SelectContent>
          {Object.values(BillingPaymentStatus).map((value) => (
            <SelectItem key={value} value={value}>
              {value?.replace("_", " ")}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default PaymentStatusSelect;
